import React from "react";

type Handlers = {
  handleTrustSolicit: () => void;
  openUlly: () => void;
  setOpenModal: (open: boolean) => void;
};

export function buildReligueModalInfos(
  status: string,
  { handleTrustSolicit, openUlly, setOpenModal }: Handlers
): any {
  switch (status) {
    case "201":
    case "422.011":
      return {
        messager: (
          <>
            <p>
              O religue foi solicitado e será efetivado em até 5 dias úteis
            </p>
            <span>Lembre-se</span>
            <ul>
              <li>
                A taxa de religue de <b>R$60,00</b> será cobrada na próxima
                fatura.
              </li>
              <li>
                É importante que, no dia da visita, o responsável pela unidade
                e/ou condomínio esteja no local para <b>liberar o acesso</b> da
                nossa equipe técnica;
              </li>
              <li>
                Para que o religue seja realizado no medidor correto, é
                obrigatório que o{" "}
                <b>número da unidade esteja visível e legível.</b> Caso a
                equipe técnica encontre alguma divergência o religue não será
                executado;
              </li>
              <li>
                Para preservar a sua segurança, a nossa equipe técnica{" "}
                <b>não liberará a válvula para a passagem do gás.</b> Com a
                finalização da prestação do serviço, assim que possível,
                verifique o registro &quot;abre e fecha&quot;, localizado no seu
                medidor, e libere a passagem do gás;
              </li>
            </ul>
          </>
        ),
        backButton: true,
      };
    case "422.007":
      return {
        messager: (
          <>
            <p>
              Não foi possível realizar a solicitação de religue da sua unidade
              pois está com o fornecimento de gás ligado.
            </p>
            <p>
              <b>
                Caso esteja sem gás, pedimos que verifique se a válvula de
                &quot;abre e fecha&quot; está aberta pois
              </b>{" "}
              para preservar a sua segurança, a nossa equipe técnica a mantém
              fechada depois de um religamento.
            </p>
          </>
        ),
        uac: true,
        backButton: true,
      };
    case "422.008":
      return {
        messager: (
          <p>
            Para medição remota, precisamos que solicite o religue com a{" "}
            <a href="#" onClick={openUlly}>
              Ully
            </a>
          </p>
        ),
        backButton: true,
      };
    case "422.009":
      return {
        messager: (
          <>
            <p>
              Não foi possível realizar a solicitação de religue da sua unidade
              pois já há uma solicitação em andamento.
            </p>
            <p>
              <b>Data limite para execução do serviço: date</b>
            </p>
          </>
        ),
        uac: true,
        backButton: true,
      };
    case "422.010":
      return {
        messager: (
          <>
            <p>
              Confirma que deseja realizar o religue de fornecimento da sua
              unidade?
            </p>
            <p>
              <b>
                Atenção: Sua unidade possui boleto(s) em aberto, se o pagamento
                não for identificado em até 2 dias úteis a unidade pode ser
                suspensa novamente.
              </b>
            </p>
            <ul>
              <li>
                A taxa de religue de <b>R$60,00</b> será cobrada na próxima
                fatura.
              </li>
              <li>
                É importante que, no dia da visita, o responsável pela unidade
                e/ou condomínio esteja no local para <b>liberar o acesso</b> da
                nossa equipe técnica;
              </li>
              <li>
                Para que o religue seja realizado no medidor correto, é
                obrigatório que o{" "}
                <b>número da unidade esteja visível e legível.</b> Caso a
                equipe técnica encontre alguma divergência o religue não será
                executado;
              </li>
              <li>
                Para preservar a sua segurança, a nossa equipe técnica{" "}
                <b>não liberará a válvula para a passagem do gás.</b> Com a
                finalização da prestação do serviço, assim que possível,
                verifique o registro &quot;abre e fecha&quot;, localizado no seu
                medidor, e libere a passagem do gás;
              </li>
            </ul>
          </>
        ),
        cancelButton: true,
        okButtom: () => handleTrustSolicit(),
      };
    case "newRule":
      return {
        messager: (
          <p>
            A solicitação de religue será liberada após a regularização dos{" "}
            <b>boletos vencidos</b>
          </p>
        ),
        uac: true,
        backButton: true,
      };
    default:
      return {
        messager: `Não foi possível solicitar o religue. Tente novamente mais tarde.`,
        cancelButton: true,
        okButtom: () => setOpenModal(false),
      };
  }
}
